<template>
    <div class="typesettingbox" :style="`height: ${maxH+50}px;`">
        <div class="bodybox">
          <div class="mbbox" :key="index" v-for="(item,index) in dataList" :style="`height:${myczcnum*1.414}px;width:${myczcnum}px;padding:${myczcnum*0.05}px;`">
              <div class="buttonbox">
                 <el-tag v-if="item.state==1" @click="updateGrowthBookComposeState(item.id,2)">上架</el-tag>
                  <el-tag v-if="item.state==2" type="danger" @click="updateGrowthBookComposeState(item.id,1)">下架</el-tag>
              </div>
            <div class="czc" v-if="item.composeNo=='czc1'" :style="`margin:${myczcnum*0.08}px ${myczcnum*0.07}px ${myczcnum*0.03}px ${myczcnum*0.15}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.70}px;width: ${myczcnum*0.70}px; background: #efefef;`">

                    </div>
                    <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.70}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.70}px;`"></div>
                </div>                                  
            </div>  
            <div class="czc" v-if="item.composeNo=='czc2'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.70}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.34}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.70}px;`">图片内容描述</div>
                    <div class="img" :style="`left:0;top:${myczcnum*0.38}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.70}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.72}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.70}px;`">图片内容描述</div>
                </div>                  
            </div>   
            <div class="czc" v-if="item.composeNo=='czc3'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="` transform: rotate(-6deg);left:${myczcnum*0.025}px;top:0;position:absolute;height: ${myczcnum*0.42}px;width: ${myczcnum*0.32}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="` transform: rotate(6deg);left:${myczcnum*0.355}px;top: ${myczcnum*0.25}px;position:absolute;height: ${myczcnum*0.42}px;width: ${myczcnum*0.32}px; background: #efefef;`">

                    </div>
                </div>                  
            </div> 
            <div class="czc" v-if="item.composeNo=='czc4'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.64}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.64}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:0;position:absolute;height: ${myczcnum*0.64}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:${myczcnum*0.36}px;top: ${myczcnum*0.64}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                </div>                  
            </div>  
            <div class="czc" v-if="item.composeNo=='czc5'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                     活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                     <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.70}px; background: #efefef;`">

                    </div>
                    <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.34}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.70}px;`">图片内容描述</div>
                    <div class="img" :style="`left:0;top:${myczcnum*0.38}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.72}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                     <div class="img" :style="`left:${myczcnum*0.38}px;top:${myczcnum*0.38}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:${myczcnum*0.38}px;top: ${myczcnum*0.72}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                </div>                  
            </div>
            <div class="czc" v-if="item.composeNo=='czc6'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                     活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                     <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.70}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                     <div class="img" :style="`left:${myczcnum*0.36}px;top:${myczcnum*0.36}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                </div>                  
            </div>  
            <div class="czc" v-if="item.composeNo=='czc7'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                     <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.340}px;width: ${myczcnum*0.30}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.32}px;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.38}px; background: #efefef;`">

                    </div>
                     <div class="img" :style="`left:0;top:${myczcnum*0.36}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.38}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.40}px;top:${myczcnum*0.36}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.30}px; background: #efefef;`">

                    </div>
                </div>                  
            </div>
            <div class="czc" v-if="item.composeNo=='czc8'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                     <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.34}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:0;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                     <div class="imgtxt" :style="`left:${myczcnum*0.36}px;top: ${myczcnum*0.34}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                     <div class="img" :style="`left:0;top:${myczcnum*0.38}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>                    
                    <div class="imgtxt" :style="`left:0;top: ${myczcnum*0.72}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:${myczcnum*0.38}px;position:absolute;height: ${myczcnum*0.34}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="imgtxt" :style="`left:${myczcnum*0.36}px;top: ${myczcnum*0.72}px;position:absolute;font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px;width: ${myczcnum*0.34}px;`">图片内容描述</div>
                </div>                  
            </div> 
            <div class="czc" v-if="item.composeNo=='czc9'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:0;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:0;top:${myczcnum*0.24}px;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:${myczcnum*0.24}px;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:0;top:${myczcnum*0.48}px;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:${myczcnum*0.48}px;position:absolute;height: ${myczcnum*0.22}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                </div>                  
            </div> 
            <div class="czc" v-if="item.composeNo=='czc10'" :style="`padding:${myczcnum*0.08}px ${myczcnum*0.03}px ${myczcnum*0.03}px ${myczcnum*0.17}px ;`">
                <div class="topbox" :style="`position:relative;`">
                    <div class="datebox" :style="` border:1px #C0C4CC solid;border-radius: ${myczcnum*0.01}px;width: ${myczcnum*0.1}px;position: absolute;left: ${-myczcnum*0.12}px; font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.04}px; text-align: center;`" >
                        <div :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.05}px`">11</div>
                        2011-11
                    </div>
                    <div class="titlebox"  :style="`font-size:${myczcnum*0.04}px;line-height: ${myczcnum*0.09}px`">
                      活动主题
                    </div>
                    <div class="txtbox" :style="`font-size:${myczcnum*0.02}px;line-height: ${myczcnum*0.038}px`">
                        活动描述，可以简单描述下活动的内容，小朋友在活动的过程中的表现，表情，动作等。
                    </div>
                </div>  
                <div class="imgbox" :style="`position:relative;height: ${myczcnum*0.70}px;margin-top:${myczcnum*0.06}px;width: ${myczcnum*0.70}px;`">
                    <div class="img" :style="`left:0;top:0;position:absolute;height: ${myczcnum*0.30}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.36}px;top:0;position:absolute;height: ${myczcnum*0.30}px;width: ${myczcnum*0.34}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:0;top:${myczcnum*0.32}px;position:absolute;height: ${myczcnum*0.38}px;width: ${myczcnum*0.30}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.32}px;top:${myczcnum*0.32}px;position:absolute;height: ${myczcnum*0.18}px;width: ${myczcnum*0.38}px; background: #efefef;`">

                    </div>
                    <div class="img" :style="`left:${myczcnum*0.32}px;top:${myczcnum*0.52}px;position:absolute;height: ${myczcnum*0.18}px;width: ${myczcnum*0.38}px; background: #efefef;`">

                    </div>
                </div>                  
            </div>
            <!-- <img src="https://wxtestfilebucket-10048617.picsh.myqcloud.com/photo/1659345471945/1659345471945_067828.png" alt="">          -->
            <!-- <img :src="item.backLogo" alt=""> -->
          </div>
        </div>        
    </div>
</template>
<script>
    import windowResize from "@/mixins/windowResize";
    import {getGrowthBookComposeList,addGrowthBookCompose,delGrowthBookComposeById,updateGrowthBookComposeState} from '@/api/growthfootprint';
    export default {
        data() {
            return {
                dataList: [],
                myczcnum:600,
                chuhsilist:[
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo1.png",composeNo:"czc1",fontColor:"",xPhotoNum:1,yPhotoNum:0},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo2.png",composeNo:"czc2",fontColor:"",xPhotoNum:2,yPhotoNum:0},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo3.png",composeNo:"czc3",fontColor:"",xPhotoNum:0,yPhotoNum:2},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo4.png",composeNo:"czc4",fontColor:"",xPhotoNum:0,yPhotoNum:2},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo5.png",composeNo:"czc5",fontColor:"",xPhotoNum:3,yPhotoNum:0},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo6.png",composeNo:"czc6",fontColor:"",xPhotoNum:2,yPhotoNum:1},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo7.png",composeNo:"czc7",fontColor:"",xPhotoNum:2,yPhotoNum:2},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo8.png",composeNo:"czc8",fontColor:"",xPhotoNum:4,yPhotoNum:0},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo9.png",composeNo:"czc9",fontColor:"",xPhotoNum:6,yPhotoNum:0},
                    {backLogo:"https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/backLogo10.png",composeNo:"czc10",fontColor:"",xPhotoNum:4,yPhotoNum:1}
                ]
            }
        },
        mixins: [windowResize],       
        created() {
            this.getGrowthBookComposeList();
        },
        methods: {  
            updateGrowthBookComposeState(id,state){
                 this.$confirm('是否'+(+state==2?'上架':'下架')+'?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateGrowthBookComposeState({id:id,state:state}).then(res => {
                        this.$message({
                            type: 'success',
                            message: (state==2?'上架':'下架')+'成功!'
                        });
                        this.getGrowthBookComposeList();
                    }).catch();

                }).catch(() => {
                });

            },
            getGrowthBookComposeList(){
                 getGrowthBookComposeList()
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                        if(this.dataList.length==0){
                            this.addGrowthBookCompose();
                        }else{
                            // for(let i=0;i<this.dataList.length;i++){                   
                            //    delGrowthBookComposeById(this.dataList[i].id)
                            //     .then(res => {})
                            //     .catch(err => {});
                            // }
                        }
                    })
            },
             addGrowthBookCompose(){
               for(let i=0;i<this.chuhsilist.length;i++){                   
                   addGrowthBookCompose(this.chuhsilist[i])
                    .then(res => {this.getGrowthBookComposeList();})
                    .catch(err => {});
                }

            },          
        }
    }
</script>

<style lang="scss" scoped>
   .typesettingbox{
       padding: 12px;
       overflow: auto;
       .mbbox{
           box-sizing: border-box;
           border:1px #C0C4CC solid;
           margin: 5px 5px;
           background: #fff;
           position: relative;
           float: left;
           .buttonbox{
               position: absolute;
               right: 20px;
               top:20px;
               cursor:pointer;
           }
           img{
               position: absolute;
               width: 100%;
               height: 100%;
               left: 0;
               top:0;
               display: block;
               z-index: 100;
           }
           .datebox{
                border: 1px solid #92B14E !important;
                background: #92B14E !important;
                color: #fff !important;
           }
       }
       .bodybox{
           width: 1240px;
           margin: 0 auto;
       }
   }
</style>



// WEBPACK FOOTER //
// src/views/growthfootprint/growthfootprinttypesettingindex.vue